import i18n from "i18next";
import {ButtonSecondary} from "@/Components/Buttons/ButtonSecondary";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import Modal from "@/Components/Modals/Modal";
import {FormRadio} from "@/Components/Controls";
import {useForm} from "@inertiajs/inertia-react";
import {useState} from "react";

export default ({
                    validationModal,
                    setValidationModal,
                    validationOptions,
                    setAddress
                }) => {

    const {data, setData, post, processing, errors} = useForm({
        radio: ""
    });

    function onChange(name, value) {
        setData(name, value);
        setUseAddressButton(true);
    }

    function hideAndResetModal(){
        setValidationModal(false);
        setUseAddressButton(false);
        setData({
            radio: ""
        });
    }

    const [use_address_button, setUseAddressButton] = useState(false);

    /**
     * validationOptions is an array that contains the values
     * that are provided by the backend for the addresses.
     * The last item in this array is the enteredAddress.
     * The remaining items in this array are the suggested address options.
     * */
    let enteredAddress = validationOptions.at(-1);
    let suggestedOptions = validationOptions.slice(0, -1);

    return (
        <Modal isOpen={validationModal}
               dialogClassName="address-validation-dialog"
               modalWrapClassName="address-validation-modal-wrap"
               modalClassName="address-validation-modal"
               setIsOpen={() => setValidationModal(!validationModal)}
               title={i18n.t("add-address.validation-modal-header")}>
            <div className="validation-modal-body">
                <div className="validation-modal-subtitle">{i18n.t("add-address.validation-modal-subtitle")}</div>
                <div className="validation-options">
                    <span className="suggested-addresses">{i18n.t("add-address.validation-modal-suggested")}</span>
                    <FormRadio
                        name="radio"
                        onChange={onChange}
                        value={data.radio}
                        options={suggestedOptions}
                        className="col-12 small"
                        dataTestid="address_validation_modal-radio-suggested_address"
                    />
                </div>
                <div className="validation-options">
                    <span className="entered-address">{i18n.t("add-address.validation-modal-entered")}</span>
                    <FormRadio
                        name="radio"
                        onChange={onChange}
                        value={data.radio}
                        options={[enteredAddress]}
                        className="col-12 small"
                        dataTestid="address_validation_modal-radio-entered_address"
                    />
                </div>
            </div>
            <div className="modal-buttons">
                <ButtonSecondary dataTestid="address_validation-button-cancel"
                                 onClick={() => setValidationModal(false)}>Cancel</ButtonSecondary>
                <ButtonPrimary dataTestid="address_validation-button-use_address" onClick={() => {
                    setAddress(validationOptions.indexOf(data.radio));
                    hideAndResetModal();
                }
                }
                               disabled={!use_address_button}
                >Use Address</ButtonPrimary>
            </div>
        </Modal>
    )
}
